import {
  Heading,
  Button,
  InputField,
  Datepicker,
  Spinner,
  ErrorMessage,
} from "@/common/components";
import { useState, useContext, useSelector, useEffect } from "@/common/hooks";
import { PrivateContext } from "@/routes/PrivateRoute";
import { useGetWithdrawalInquiryMutation } from "@/service/OwnerService";
import { setEditProjectionsResponse } from "@/store/ownersSlice";
import dayjs from "dayjs";

const SpouseDobProjection = () => {
  const {
    labels,
    cancel,
    productSponsorId,
    accessProfileId,
    dispatch,
    setNavHeader,
  } = useContext(PrivateContext);

  const [projectedOwnerAge, setProjectedOwnerAge] = useState("");
  const [spouseDob, setSpouseDob] = useState("");
  const [ownershipInquiryDetails, setOwnershipInquiryDetails] = useState();
  const [errors, setErrors] = useState({});

  const [getWithdrawalInquiryApi, { isLoading: isFetching, error }] =
    useGetWithdrawalInquiryMutation();

  const ownershipInquiryResultFromStore = useSelector(
    (state) => state?.ownersReducer?.ownershipInquiryResult
  );

  useEffect(() => {
    if (ownershipInquiryResultFromStore)
      setOwnershipInquiryDetails(ownershipInquiryResultFromStore);
  }, [ownershipInquiryResultFromStore]);

  useEffect(() => {
    setNavHeader(labels?.ownerInquiry?.title);
  }, []);

  const validateProjectedAge = (value) => {
    if(!value) {
      setErrors((prev) => ({...prev, projectedOwnerAge: ""}))
      setProjectedOwnerAge("")
      return;
    }
    if (
      ownershipInquiryDetails?.productOwnerAge &&
      value <= parseInt(ownershipInquiryDetails.productOwnerAge)
    ) {
      setErrors((prev) => ({
        ...prev,
        projectedOwnerAge:
          labels?.ownerInquiry?.projectionAgeError
      }));
    } else {
      setErrors((prev) => ({ ...prev, projectedOwnerAge: "" }));
    }
    setProjectedOwnerAge(value);
  };
  
  const handleSpouseDobChange = (value) => {
    const formattedValue = dayjs(value).format("MM/DD/YYYY");
    setSpouseDob(formattedValue);
  };

  const handleSubmit = () => {
    if (errors.projectedOwnerAge || errors.spouseDob) return;

    const {
      lineOfBusinessId,
      ownershipType,
      ownerTaxId,
      planId,
      externalProductId,
      recordKeeperName,
      recordKeepingSystemName,
    } = ownershipInquiryDetails;

    const getWithdrawalInquiryPayload = {
      lineOfBusinessId: lineOfBusinessId,
      ownershipTypeCode: ownershipType,
      ownerTaxId: ownerTaxId,
      planId: planId,
      externalProductId: externalProductId,
      recordKeeperName: recordKeeperName,
      recordKeepingSystemName: recordKeepingSystemName,
      hypotheticalOwnerAge: projectedOwnerAge,
      jointAnnuitantBirthDate: spouseDob,
      productSponsorId: productSponsorId,
      accessProfileId: accessProfileId,
    };

    getWithdrawalInquiryApi(getWithdrawalInquiryPayload)
      .unwrap()
      .then((res) => {
        if (!res.errors.length) {
          dispatch(setEditProjectionsResponse(res));
          cancel();
        }
      })
  };

  return (
    <section className="container-medium py-5">
      {isFetching && <Spinner />}
      <ErrorMessage error={error} wrapperClassName="mb-3" />
      <Heading
        text={labels?.ownerInquiry?.projectionModalHeading}
        title={false}
        wrapperClassNames="h4 mb-4"
      />

      <div className="mb-4">
        <InputField
          type="number"
          label={labels?.ownerInquiry?.projectionModalAgeLabel}
          inputClass={`form-control w-50 ${
            errors.projectedOwnerAge ? "is-invalid" : ""
          }`}
          wrapperClassName="mb-2"
          change={validateProjectedAge}
          value={projectedOwnerAge}
          min="0"
          step="1"
          name="projectedAge"
          id="projectedAge"
        />
        {errors.projectedOwnerAge && (
          <p className="text-danger small mt-1">{errors.projectedOwnerAge}</p>
        )}
      </div>

      <Datepicker
        id="spouseDob"
        value={spouseDob}
        wrapperClassName="w-auto mb-5"
        change={handleSpouseDobChange}
        max={dayjs()}
        label={labels?.ownerInquiry?.projectionModalDobLabel}
      />

      <div className="d-flex justify-content-end justify-content-md-end mt-5">
        <Button
          id="cancel"
          type="secondary"
          text={labels?.ownerInquiry?.cancel}
           wrapperClassName="col-md-2 me-1 col-6"
          click={cancel}
        />
        <Button
          id="submit"
          text={labels?.ownerInquiry?.submit}
           wrapperClassName="col-md-2 me-1 col-6"
          click={handleSubmit}
          disabled={
            !spouseDob && !projectedOwnerAge || !!errors.projectedOwnerAge
          }
          
        />
      </div>
    </section>
  );
};

export default SpouseDobProjection;
